module.exports = __webpack_public_path__ + "static/media/APC_Sluiten.7fde6185.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/05/01/assets/APC_Sluiten.mp3
// module id = 551
// module chunks = 0